<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TpoYu7/tc-custom/9780226922454.jpg?1736424821564" alt="This image is the cover for the book Sexual Politics, Sexual Communities"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sexual Politics, Sexual Communities
      </h1>
      <p class="bookDescription body article font2">
        <p>With thorough documentation of the oppression of homosexuals and biographical sketches of the lesbian and gay heroes who helped the contemporary gay culture to emerge, <i>Sexual Politics, Sexual Communities</i> supplies the definitive analysis of the homophile movement in the U.S. from 1940 to 1970. John D'Emilio's new preface and afterword examine the conditions that shaped the book and the growth of gay and lesbian historical literature.<br/><br/> "How many students of American political culture know that during the McCarthy era more people lost their jobs for being alleged homosexuals than for being Communists? . . . These facts are part of the heretofore obscure history of homosexuality in America—a history that John D'Emilio thoroughly documents in this important book."—George DeStefano, <i>Nation</i><br/><br/> "John D'Emilio provides homosexual political struggles with something that every movement requires—a sympathetic history rendered in a dispassionate voice."—<i>New York Times Book Review</i><br/><br/> "A milestone in the history of the American gay movement."—Rudy Kikel, <i>Boston Globe</i><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John D'Emilio
      </h2>
      
      <p class="authorDescription body article">Please fill in author biography</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d8ad745